import en from "config/strings/en"
import { isEmpty } from "lodash"
import { validateEmail, validatePhoneNumber } from "utils/validation"

const validate = (values) => {
    const { name, phone, principal_phone, principal_email, principal_last_name, principal_first_name, contact_phone, contact_last_name, contact_first_name, institution_code, address, city, logo, contact_email, email, affiliation_name, contant_name, principal_name, phone_number } = values || {}
    const errors = {}

    if (!name) errors.name = en.require()

    if (phone)
        errors.phone = validatePhoneNumber(values.phone)
    else
        errors.phone = en.require()

    if (email)
        errors.email = validateEmail(values.email)
    else errors.email = en.require()

    if (!institution_code) errors.institution_code = en.require()

    if (!contact_first_name) errors.contact_first_name = en.require()
    if (!contact_last_name) errors.contact_last_name = en.require()

    if (contact_email)
        errors.contact_email = validateEmail(values.contact_email)
    else errors.contact_email = en.require()

    if (contact_phone)
        errors.contact_phone = validatePhoneNumber(values.contact_phone)
    else errors.contact_phone = en.require()

    if (isEmpty(city?.name)) errors.city = en.require()

    return errors;
}

export default validate